export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00420.5c04d771.png";